<template><div><h1 id="konfigurierbarer-bereich-personen" tabindex="-1"><a class="header-anchor" href="#konfigurierbarer-bereich-personen"><span>Konfigurierbarer Bereich Personen</span></a></h1>
<p>Konfigurierbarer Bereich Personen — Einrichtung Datenanzeige im konfigurierbaren Bereich der Personen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden die Daten für die Anzeige im konfigurierbaren Bereich der Personenansicht definiert. Die Tabelle wird mit dem Systemparameter &quot;kinf&quot; synchronisiert. Deshalb sind z. T. Vorschlagswerte, wie &quot;true&quot;/&quot;false&quot;, in englischer Sprache verfasst.</p>
<p>Einige Einträge in dieser Tabelle erfordern vertieftes Know-How über die Datenbank und die Services von funtrade und müssen bei Arenae angefragt resp. durch Arenae selbst parametrisiert werden.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Konfigurierbarer Bereich Person</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>ID</dt>
<dd>Nummer des Eintrages. Bestimmt die Reihenfolge der Anzeige.</dd>
<dt>Typ</dt>
<dd>Typ des anzuzeigenden Feldes. Folgende Typen stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Typ</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AddressFieldInfoField</td>
<td>Zeigt ein beliebiges Feld aus dem Personen-Service an, z.B. Sprachcode (sprachcd), Dublette (l-doubladr), Haushaltsperson (l-haushalt), Organisatorische Einheit (ehcodes) oder Beschreibung der Sperre (l-sperre).</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Haushaltsbeziehung mit:&quot;, ausblenden wenn leer?= &quot;true&quot;, Feld-ID: &quot;l-haushalt&quot;.</td>
</tr>
<tr>
<td>BeziehungField</td>
<td>Zeigt Daten aus den Personenbeziehungen. Hier ein Erfassungsbeispiel für die Anzeige einer Persoen-ID der Beziehung &quot;Lehrer&quot; mit Verlinkung:</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Lehrer:&quot; (Achtung: Richtung ist/hat wird nicht unterschieden), ausblenden wenn leer?= &quot;true&quot;, Feld-ID: &quot;ladrnum&quot;, Beziehung: &quot;Lehrer&quot;, List-ID: &quot;BeziehungenAdrList&quot;, Query-ID: &quot;nm461_aktive&quot;, Navigationtarget: &quot;ch.arenae.funtrade.client.personen&quot;.</td>
</tr>
<tr>
<td>ChildServiceField2</td>
<td>Ermöglicht die Anzeige von Daten aus Child-Services, z.B. für die Anzeige von Drittzahlern aus den Zusagen.</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Bezahlt durch:&quot;, ausblenden wenn leer?= &quot;true&quot;, Feld-ID: &quot;durchAdrnum&quot;, List-ID: &quot;BezahltDurchAdrList&quot;, Query-ID: &quot;nm461_aktive&quot;, Navigationtarget: &quot;ch.arenae.funtrade.client.personen&quot;.</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Zahlt für:&quot;, ausblenden wenn leer?= &quot;true&quot;, Feld-ID: &quot;adrfuer&quot;, List-ID: &quot;ZahltFuerAdrList&quot;, Query-ID: &quot;nm461_aktive&quot;, Navigationtarget: &quot;ch.arenae.funtrade.client.personen&quot;.</td>
</tr>
<tr>
<td>EditorInfoField</td>
<td>Mit diesem Typ können spezielle Editoren wie z.B. die RFM Grafik eingebunden werden.</td>
</tr>
<tr>
<td>MerkmalField</td>
<td>Zeigt ein einzelnes Merkmal der Person an.</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Verdankung:&quot;, ausblenden wenn leer?= &quot;true&quot;, Farbe Wert: &quot;(255,0,0)&quot;, Merkmal-ID: 25</td>
</tr>
<tr>
<td></td>
<td>Label:&quot;Verdankung:&quot;, ausblenden wenn leer?= &quot;true&quot;, Farbe Wert: &quot;(255,0,0)&quot;, Merkmal: &quot;keine Verdankung&quot;</td>
</tr>
<tr>
<td>MerkmalGruppeField</td>
<td>Zeigt Merkmale aus einer Merkmalgruppe der Person an.</td>
</tr>
<tr>
<td></td>
<td>Alle Merkmale einer Gruppe anzeigen:Label:&quot;Merkmale Person:&quot;, include all: &quot;true&quot;, ausblenden wenn leer?= &quot;true&quot;, Merkmalgruppen-ID: 1davon einzelne Merkmale ausschliessen:Label:&quot;Merkmale Person:&quot;, include/exclude: &quot;exclude&quot;, Merkmal-ID: 10</td>
</tr>
<tr>
<td></td>
<td>Einzelne Merkmale einer Gruppe anzeigen:Label:&quot;Merkmale Person:&quot;, include: &quot;&quot;, ausblenden wenn leer?= &quot;true&quot;, Merkmalgruppen-ID: 1dann beliebige Merkmale, ausgehend von der erfasssten Zeile, ergänzen:Label:&quot;Major Donor:&quot;, include/exclude: &quot;include&quot;, ausblenden wenn leer?= &quot;true&quot;, Merkmal-ID: 12</td>
</tr>
<tr>
<td>PublikationenField</td>
<td>Zeigt einzelne oder mehrere Publikationen zu der Person an.</td>
</tr>
<tr>
<td></td>
<td>Alle Publikationen anzeigen:Label:&quot;Publikationen:&quot;, Include all: &quot;true&quot;, ausblenden wenn leer?= &quot;true&quot;, Publikationen: &quot;&quot;</td>
</tr>
<tr>
<td></td>
<td>Einzelne Publikation(en) anzeigen:Label:&quot;Publikationen&quot;, in/exclude: &quot;&quot;, ausblenden wenn leer?= &quot;true&quot;dann beliebige Publikation(en), ausgehend von der erfasssten Zeile, ergänzen:Label:&quot;Weihnachtskarte&quot;, in/exclude: &quot;include&quot;, ausblenden wenn leer?= &quot;true&quot;, Publikation: &quot;Weihnachtskarte&quot;</td>
</tr>
</tbody>
</table>
</dd>
<dt>Label</dt>
<dd>Der Eintrag wird als Label zum Feld angezeigt.</dd>
<dt>Include all</dt>
<dd>Wählt z.B. bei Merkmalgruppen und Publikationen alle Datensätze aus. Einzelne Datensätze können davon ausgeschlossen werden wenn nachfolgend (über ID gesteuert) Zeilen vom selben Typ mit der Option &quot;exclude&quot; erfasst sind.</dd>
<dt>in/exclude</dt>
<dd>Schliesst einzelne Datensätze ein oder aus. Bedingung ist, dass eine Parent-Zeile vom selben Typ erfasst ist.</dd>
<dt>ausblenden wenn leer?</dt>
<dd>Wenn keine Daten zum anzeigen vorhanden sind, wird die ganze Zeile (inkl. Label) ausgeblendet.</dd>
<dt>Field-ID</dt>
<dd>Feld-ID aus einem Service oder Subservice (muss bei Arenae angefragt werden).</dd>
<dt>Format</dt>
<dd>Ein Editor-spezifisches Format. Dient z.B. dazu, Zahlen mit/ohne 1'000er-Trennzeichen oder spezifische Texte statt &quot;true/false&quot; auszugeben.</dd>
<dt>Multi</dt>
<dd>Der Inhalt eines Textblockes wird, um 1 Zeile versetzt, unterhalb des Labels dargestellt.</dd>
<dt>Farbe Label</dt>
<dd>RGB-Farbcode für das Label in folgendem Format: (255,0,0).</dd>
<dt>Farbe Wert</dt>
<dd>RGB-Farbcode für den angezeigten Wert. Format siehe oben.</dd>
<dt>Merkmalgruppen-ID</dt>
<dd>Interne ID eines übergeordneten Merkmals. Die interne ID vom Merkmal kann im Kontextmenü, unter &quot;Info...&quot; abgefragt werden. Es handelt sich um die Zahl im Eintrag &quot;Selection: [TEigenschaftKopfBuffer[1102]]&quot;.</dd>
<dt>Merkmal-ID</dt>
<dd>Interne ID des Merkmals.</dd>
<dt>Merkmal</dt>
<dd>Merkmal-Eintrag. Wenn möglich dieses Feld nicht nutzen. Es sollte die Merkmal-ID verwendet werden. Ansonsten funktioniert die Anzeige nach einer allfälligen Umbenennung des Merkmals nicht mehr.</dd>
<dt>Wert mit Merkmal</dt>
<dd>Standardmässig wird bei Merkmalen mit Werttyp ungleich &quot;ohne Wert&quot; nur der Wert angezeigt. Wenn diese Option auf &quot;true&quot; gesetzt ist, wird das Merkmal mit dem Wert in Klammer angezeigt. Muss zwingend auf &quot;true&quot; gesetzt sein, für die Anzeige von Merkmalen mit Werttyp &quot;ohne Wert&quot;.</dd>
<dt>Publikation</dt>
<dd>Einzelne Publikation, die mit &quot;in/exclude&quot; hinzugefügt oder ausgeblendet wird.</dd>
<dt>Beziehung</dt>
<dd>Beziehung, deren Daten angezeigt werden sollen.</dd>
<dt>List-ID</dt>
<dd>Nur in Verbindung mit Typ &quot;ChildServiceField2&quot;. Child-Service, aus dem Daten angezeigt werden sollen (muss bei Arenae angefragt werden).</dd>
<dt>Query-ID</dt>
<dd>Nur in Verbindung mit Typ &quot;ChildServiceField2&quot;. Query für die Filterung. Z.B. nur aktive Daten anzeigen (muss bei Arenae angefragt werden).</dd>
<dt>Navigationtarget</dt>
<dd>Bewirkt ein Verlinkung der angezeigten Daten mit Angabe der Ziel-View, die geöffnet werden soll (muss bei Arenae angefragt werden).</dd>
<dt>Editor-ID</dt>
<dd>Nur in Verbindung mit Typ &quot;EditorInfoField&quot;. Eintrag des Editors, der für die Anzeige aufgerufen werden soll (muss bei Arenae angefragt werden).</dd>
</dl>
</div></template>


